import clsx from 'clsx';
import { h, Fragment } from 'preact';

const RichText = ({ data, customRootClass = '' }) => {
  const serializeRichTextASTNode = (node, index = 0) => {
    switch (node.type) {
      case 'root':
        return (
          <div
            key={index}
            className={clsx('rte mb-6 font-13', customRootClass)}
          >
            {node.children?.map(serializeRichTextASTNode)}
          </div>
        );
      case 'heading':
        return h(
          `h${node.level ?? '1'}`,
          null,
          node.children?.map(serializeRichTextASTNode),
        );
      case 'paragraph':
        return (
          <p key={index}>{node.children?.map(serializeRichTextASTNode)}</p>
        );
      case 'text':
        return (
          <>
            {node.value && (
              <span
                key={index}
                className={clsx(
                  node.bold && 'font-medium',
                  node.italic && 'italic',
                )}
              >
                {node.value}
              </span>
            )}
          </>
        );
      case 'link':
        return (
          <a
            key={index}
            href={node.url}
            title={node.title}
            target={node.target}
          >
            {node.children?.map(serializeRichTextASTNode)}
          </a>
        );
      case 'list':
        // eslint-disable-next-line no-case-declarations
        const List = node.listType === 'unordered' ? 'ul' : 'ol';

        return (
          <List key={index}>
            {node.children?.map((item) => {
              if (!item.children) {
                return null;
              }

              return (
                <li key={item.children[0].value}>
                  {item.children.map(serializeRichTextASTNode)}
                </li>
              );
            })}
          </List>
        );
      default:
        return null;
    }
  };

  return serializeRichTextASTNode(data);
};

export default RichText;
